document.addEventListener("DOMContentLoaded", () => {
  const iconCardAccordionToggle = document.querySelectorAll('.icon-card-accordion__toggle');
  if (iconCardAccordionToggle !== undefined) {
    iconCardAccordionToggle.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        const parent = e.target.closest('.icon-card-accordion');
        parent.querySelector('.icon-card-accordion__toggle').classList.toggle('active');
        parent.querySelector('.icon-card-accordion__content').classList.toggle('active');
      });
    });
  }
});
